<template>
  <div class="batch-search search-box">
    <!-- 筛选条件 -->
    <div class="search-block border-bottom-divide">
      <span class="label search-label">筛选条件</span>
      <span class="label keyword-label">品牌</span>
      <el-select
          class="select-input"
          v-model="searchObj.brandCode"
          value-key="id"
          placeholder="不限"
          :disabled="from === 'FanCoilOthers'"
          @change="(code) => selectSeries(code)"
      >
        <el-option label="不限" value="" />
        <el-option
            v-for="v in brands"
            :key="v.brandCode"
            :label="v.brandName"
            :value="v.brandCode"
        />
      </el-select>
      <span class="label keyword-label">结构形式</span>
      <el-select
          class="select-input"
          v-model="searchObj.structuresCode"
          value-key="id"
          placeholder="请选择"
          :disabled="from === 'FanCoilOthers'"
          @change="(code) => selectStructures(code)"
      >
        <el-option
            v-for="(v, i) in structures"
            :key="i"
            :label="v.name"
            :value="v.code"
        />
      </el-select>
      <span class="label keyword-label">安装形式</span>
      <el-select
          class="select-input"
          v-model="searchObj.installationsCode"
          value-key="id"
          placeholder="请选择"
          :disabled="from === 'FanCoilOthers'"
          @change="(code) => selectInstallations(code)"
      >
        <el-option
            v-for="(v, i) in installations"
            :key="i"
            :label="v.name"
            :value="v.code"
        >
        </el-option>
      </el-select>
    </div>
    <!-- 选型挡位 -->
    <div class="search-block border-bottom-divide">
      <div class="search-unit after-line">
        <span class="label search-label">选型挡位</span>
        <span class="label keyword-label">
          <el-radio v-model="searchObj.level" label="MEDIUM_LEVEL" @change="changeTracksCondition">中档</el-radio>
          <el-radio v-model="searchObj.level" label="HIGH_LEVEL" @change="changeTracksCondition">高档</el-radio>
        </span>
        <!--整数类型-->
        <span class="label">积灰修正附加率</span>
        <el-input
            ref="dustCorrectionFactor"
            class="narrow"
            v-model="searchObj.dustCorrectionFactor"
            :disabled="isMediumLevel"
            @blur="dustCorrectionChange"
            oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
        >
          <template #append>%</template>
        </el-input>
        <span class="label keyword-label">间歇运行附加率</span>
        <el-input
            ref="intermittentUseFactor"
            class="narrow"
            v-model="searchObj.intermittentUseFactor"
            :disabled="isMediumLevel"
            @blur="intermittentChange"
            oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
        >
          <template #append>%</template>
        </el-input>
      </div>
      <div class="search-unit after-line">
        <span class="label">工况修正</span>
        <span class="label keyword-label">夏季供水温度</span>
        <el-input
            ref="summerSupplyWaterTemperature"
            class="narrow"
            v-model="searchObj.summerSupplyWaterTemperature"
            @blur="summerSupplyWaterChange"
            oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
        >
          <template #append>℃</template>
        </el-input>
        <span class="label keyword-label">冬季供水温度</span>
        <el-input
            ref="winterSupplyWaterTemperature"
            class="narrow"
            v-model="searchObj.winterSupplyWaterTemperature"
            @blur="winterSupplyWaterChange"
            oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
        >
          <template #append>℃</template>
        </el-input>
      </div>
      <div class="search-unit">
        <span class="label">台数划分</span>
        <span class="label keyword-label">单台承担面积</span>
        <el-input
            ref="singleUnitResponsibilityArea"
            class="narrow"
            v-model="searchObj.singleUnitResponsibilityArea"
            @blur="singleUnitChange"
            :disabled="from === 'FanCoilOthers'"
            oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
        >
          <template #append>m²</template>
        </el-input>
      </div>
    </div>
    <!-- 校核设置 -->
    <div class="search-block border-bottom-divide">
      <span class="label search-label">校核设置</span>
      <div class="label valid-box">
        <el-checkbox-group class="keyword-label" v-model="searchObj.validChecked" @change="changeTracksCondition">
          <el-checkbox v-for="(item, index) in validList" :key="index" :label="item.id">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
        <div class="keyword-label">
          <el-checkbox style="margin-right: 14px;" v-model="searchObj.staticPressure" @change="changeTracksCondition">机外静压</el-checkbox>
          <el-input
              ref="fromPa"
              class="narrow"
              v-model="searchObj.fromPa"
              :disabled="!searchObj.staticPressure"
              @blur="fromPaChange"
              oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
          >
            <template #append>Pa</template>
          </el-input>
          <span> ~ </span>
          <el-input
              ref="toPa"
              class="narrow"
              v-model="searchObj.toPa"
              :disabled="!searchObj.staticPressure"
              @blur="toPaChange"
              oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
          >
            <template #append>Pa</template>
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FanCoilSearch',
  props: {
    initValue: {
      type: Object,
      default() {
        return {
          brandName: '',
          brandCode: '',
          structuresName: '',
          structuresCode: '',
          installationsName: '',
          installationsCode: '',
          level: 'MEDIUM_LEVEL', // 默认中档
          dustCorrectionFactor: '10',
          intermittentUseFactor: '10',
          summerSupplyWaterTemperature: '7',
          winterSupplyWaterTemperature: '60',
          singleUnitResponsibilityArea: '20',
          staticPressure: false,
          validChecked: [1, 2, 3, 6],
          fromPa: '12',
          toPa: '30',
        }
      }
    },
    temperatureMin: [String, Number],
    temperatureMax: [String, Number],
    from: {
      type: String,
      default: 'FanCoil',
    },
  },
  data() {
    return {
      searchObj: this.initValue,
      g_c_default_condition: true,
      validList: [
        {
          id: 1,
          name: '送风量',
          mediumCode: 'P000307',
          highCode: 'P000252',
        },
        {
          id: 2,
          name: '全热冷量',
          mediumCode: 'P000294',
          highCode: 'P000121',
        },
        {
          id: 3,
          name: '显热冷量',
          mediumCode: 'P000295',
          highCode: 'P000122',
        },
        {
          id: 4,
          name: '潜热冷量',
          mediumCode: 'P000296',
          highCode: 'P000291',
        },
        {
          id: 5,
          name: '热湿比',
          mediumCode: 'P000297',
          highCode: 'P000292',
        },
        {
          id: 6,
          name: '制热量',
          mediumCode: 'P000298',
          highCode: 'P000293',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      brands: 'list/brands',
      aggProperties: 'fanList/aggProperties'
    }),
    // 结构形式选项
    structures() {
      const propertyObj = this.aggProperties.find((item) => item.name === '结构形式') || {}
      const valueArr = propertyObj.values || []
      const allOpts = ['卧式', '立式', '卡式', '挂壁式']
      const options = []
      allOpts.forEach((opt) => {
        const v = valueArr.find((it) => it.name === opt)
        if (v) {
          options.push(v)
        }
      })
      return options
    },
    // 安装形式选项
    installations() {
      const propertyObj = this.aggProperties.find((item) => item.name === '安装形式') || {}
      const valueArr = propertyObj.values || []
      const allOpts = ['暗装', '明装']
      const options = []
      allOpts.forEach((opt) => {
        const v = valueArr.find((it) => it.name === opt)
        if (v) {
          options.push(v)
        }
      })
      return options
    },
    isMediumLevel() {
      return this.searchObj.level === 'MEDIUM_LEVEL'
    }
  },
  watch: {
    initValue(newVal) {
      this.searchObj = newVal ? { ...newVal } : {}
    },
    structures: {
      handler(val) {
        if (this.searchObj.structuresCode) { return }
        const firstItem = val[0]
        // console.log('firstItem', firstItem)
        this.searchObj.structuresName = firstItem ? firstItem.name : ''
        this.searchObj.structuresCode = firstItem ? firstItem.code : ''
      },
      immediate: true
    },
    installations: {
      handler(val) {
        if (this.searchObj.installationsCode) { return }
        const firstItem = val[0]
        this.searchObj.installationsName = firstItem ? firstItem.name : ''
        this.searchObj.installationsCode = firstItem ? firstItem.code : ''
      },
      immediate: true
    },
  },
  methods: {
    // 挡位切换
    changeTracksCondition() {
      this.g_c_default_condition = false
    },
    // 品牌筛选
    selectSeries(code) {
      this.searchObj.brandCode = code
      const item = this.brands.find((item) => { return item.brandCode === code }) || {}
      this.searchObj.brandName = item.brandName
      this.g_c_default_condition = false
    },

    // 结构形式
    selectStructures(code) {
      const item = this.structures.find((i) => i.code === code) || {}
      this.searchObj.structuresName = item.name
      this.g_c_default_condition = false
    },
    // 安装形式
    selectInstallations(code) {
      const item = this.installations.find((i) => i.code === code) || {}
      this.searchObj.installationsName = item.name
      this.g_c_default_condition = false
    },
    // 积灰修正附加率
    dustCorrectionChange() {
      this.g_c_default_condition = false
      if (!this.searchObj.dustCorrectionFactor) {
        this.$message({
          message: '积灰修正附加率不能为空',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.$refs.dustCorrectionFactor.focus()
      }
    },
    // 间歇运行附加率
    intermittentChange() {
      this.g_c_default_condition = false
      if (!this.searchObj.intermittentUseFactor) {
        this.$message({
          message: '间歇运行附加率不能为空',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.$refs.intermittentUseFactor.focus()
      }
    },
    // 夏季供水温度（℃）
    summerSupplyWaterChange() {
      this.g_c_default_condition = false
      if (!this.searchObj.summerSupplyWaterTemperature) {
        this.$message({
          message: '夏季供水温度（℃）不能为空',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.$refs.summerSupplyWaterTemperature.focus()
      }
      if (this.searchObj.summerSupplyWaterTemperature > this.temperatureMin) {
        this.searchObj.summerSupplyWaterTemperature = ''
        this.$refs.summerSupplyWaterTemperature.focus()
        this.$message({
          message: '夏季供水温度应小于夏季室内干、湿球温度，请重新输入',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
      }
    },

    // 冬季供水温度（℃）
    winterSupplyWaterChange() {
      this.g_c_default_condition = false
      if (!this.searchObj.winterSupplyWaterTemperature) {
        this.$message({
          message: '冬季供水温度（℃）不能为空',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.$refs.winterSupplyWaterTemperature.focus()
      }
      if (this.searchObj.winterSupplyWaterTemperature < this.temperatureMax) {
        this.winterSupplyWaterTemperature = ''
        this.$refs.winterSupplyWaterTemperature.focus()
        this.$message({
          message: '冬季供水温度应大于冬季室内干球温度，请重新输入',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
      }
    },

    // 单台承担面积
    singleUnitChange() {
      this.g_c_default_condition = false
      if (!this.searchObj.singleUnitResponsibilityArea) {
        this.$message({
          message: '单台承担面积不能为空',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.$refs.singleUnitResponsibilityArea.focus()
      }
    },
    // 机外静压最小值
    fromPaChange() {
      if (!this.searchObj.fromPa && this.searchObj.fromPa !== 0) {
        this.$message({
          message: '机外静压不能为空',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.$refs.fromPa.focus()
      } else if (Number(this.searchObj.fromPa) > Number(this.searchObj.toPa)) {
        this.fromPa = ''
        this.$refs.fromPa.focus()
        this.$message({
          message: '最大值不能小于最小值',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
      }
    },

    // 机外静压最大值
    toPaChange() {
      if (!this.searchObj.toPa && this.searchObj.toPa !== 0) {
        this.$message({
          message: '机外静压不能为空',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.$refs.toPa.focus()
      } else if (Number(this.fromPa) > Number(this.toPa)) {
        this.toPa = ''
        this.$refs.toPa.focus()
        this.$message({
          message: '最大值不能小于最小值',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
      }
    },

    // 获取搜索参数
    getSearchData() {
      // 参数组装
      const productProperties = []
      const validProperties = []
      const nonValidProperties = []
      if (this.searchObj.structuresCode) {
        productProperties.push({
          code: 'P000003',
          parameterType: 'Enums',
          queryType: 'EQUAL',
          value: this.searchObj.structuresCode,
        })
      }
      if (this.searchObj.installationsCode) {
        productProperties.push({
          code: 'P000006',
          parameterType: 'Enums',
          queryType: 'EQUAL',
          value: this.searchObj.installationsCode,
        })
      }
      if (this.searchObj.staticPressure) {
        validProperties.push({
          code: 'P000097',
          parameterType: 'Double',
          queryType: 'RANGE_TE',
          from: this.searchObj.fromPa,
          to: this.searchObj.toPa,
        })
      } else {
        nonValidProperties.push({
          code: 'P000097',
        })
      }
      // 组装校核参数
      const key = this.isMediumLevel ? 'mediumCode' : 'highCode'
      this.validList.forEach((item) => {
        if (this.searchObj.validChecked.includes(item.id)) {
          validProperties.push({ code: item[key] })
        } else {
          nonValidProperties.push({ code: item[key] })
        }
      })
      return {
        isMediumLevel: this.isMediumLevel,
        searchData: this.searchObj,
        productProperties,
        validProperties,
        nonValidProperties,
        g_c_default_condition: this.g_c_default_condition,
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search-block {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding: 8px 0;
  line-height: 24px;
  .label {
    height: 24px;
    line-height: 24px;
    margin-right: 6px;
  }
  .switch {
    margin: 4px 16px 4px 0;
  }
}
.search-unit{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin-left: 0;
  &.after-line{
    position: relative;
    margin-right: 24px;
    &:after{
      content: '';
      height: 16px;
      width: 1px;
      background: #ccc;
      right: -12px;
      top: 4px;
    }
  }
}
.select-input {
  width: 108px;
}
.keyword-label {
  margin: 0 6px 0 16px;
}
.search-label {
  margin-right: 8px;
}
.narrow {
  width: 73px;
}
.valid-box{
  display: flex;
  flex-direction: row;
}
</style>
